import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardBodyComponent } from './components/card-body.component';
import { CardFooterComponent } from './components/card-footer.component';
import { CardHeaderComponent } from './components/card-header.component';
import { CirrusCardComponent } from './cirrus-card.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    CirrusCardComponent,
    CardHeaderComponent,
    CardBodyComponent,
    CardFooterComponent
  ],
  exports: [
    CirrusCardComponent,
    CardHeaderComponent,
    CardBodyComponent,
    CardFooterComponent
  ]
})
export class CirrusCardModule {}
